import styled from 'styled-components'

import { ChartAnnotation } from '@/components/elements/ChartAnnotation'
import { Spacer } from '@/components/elements/Spacer'
import { Table } from '@/components/layouts/Ir/Mpocket/THDTable'

export const PLTable = () => {
  return (
    <>
      <Annotation>(Millions of Yen)</Annotation>
      <Spacer h={{ sp: 6, pc: 10 }} />
      <Table id="irp-highlight-table-pl_en" content='ir-financial-cfs_en'/>
    </>
  )
}

export const BSTable = () => {
  return <Table id="irp-highlight-table-bs_en" content='ir-financial-cfs_en'/>
}

export const CFTable = () => {
  return <Table id="irp-highlight-table-cf_en" content='ir-financial-cfs_en'/>
}

const Annotation = styled(ChartAnnotation)`
  text-align: right;
`

